import { ManageBookingActionValue } from '@constants/manageBookingActions'
import helpers from '@lib/analytics/amplitude/helpers'

const { sendEvent } = helpers

const manageBookingAction = (actionType: ManageBookingActionValue): void => {
  sendEvent('manage-booking-action', {
    actionType,
  })
}

export default {
  manageBookingAction,
}
